// NavigationContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [stack, setStack] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fullPath = `${location.pathname}${location.search}`;
    setStack(prev => {
      if (prev.length === 0 || prev[prev.length - 1] !== fullPath) {
        return [...prev, fullPath];
      }
      return prev;
    });
  }, [location]);

  const goBack = () => {
    setStack(prev => {
      if (prev.length > 1) {
        const newStack = [...prev];
        newStack.pop(); // remove current
        const last = newStack[newStack.length - 1];
        navigate(last);
        return newStack;
      }
      return prev;
    });
  };

  return (
    <NavigationContext.Provider value={{ goBack }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
